
      import {$emit} from 'uni-helpers/protocol/base/event-bus.js'
import {$on} from 'uni-helpers/protocol/base/event-bus.js'
import {addInterceptor} from 'uni-helpers/protocol/base/interceptor.js'
import {arrayBufferToBase64} from 'uni-helpers/protocol/base/base64.js'
import {base64ToArrayBuffer} from 'uni-helpers/protocol/base/base64.js'
import {canIUse} from 'uni-helpers/protocol/base/can-i-use.js'
import {canvasToTempFilePath} from 'uni-helpers/protocol/context/canvas.js'
import {chooseFile} from 'uni-helpers/protocol/media/choose-file.js'
import {chooseImage} from 'uni-helpers/protocol/media/choose-image.js'
import {chooseVideo} from 'uni-helpers/protocol/media/choose-video.js'
import {connectSocket} from 'uni-helpers/protocol/network/socket.js'
import {createCanvasContext} from 'uni-helpers/protocol/context/context.js'
import {downloadFile} from 'uni-helpers/protocol/network/download-file.js'
import {getStorageSync} from 'uni-helpers/protocol/storage/storage.js'
import {navigateBack} from 'uni-helpers/protocol/route/route.js'
import {navigateTo} from 'uni-helpers/protocol/route/route.js'
import {reLaunch} from 'uni-helpers/protocol/route/route.js'
import {redirectTo} from 'uni-helpers/protocol/route/route.js'
import {removeStorageSync} from 'uni-helpers/protocol/storage/storage.js'
import {request} from 'uni-helpers/protocol/network/request.js'
import {setClipboardData} from 'uni-helpers/protocol/device/set-clipboard-data.js'
import {setNavigationBarColor} from 'uni-helpers/protocol/ui/navigation-bar.js'
import {setStorageSync} from 'uni-helpers/protocol/storage/storage.js'
import {showLoading} from 'uni-helpers/protocol/ui/popup.js'
import {showModal} from 'uni-helpers/protocol/ui/popup.js'
import {showToast} from 'uni-helpers/protocol/ui/popup.js'
import {switchTab} from 'uni-helpers/protocol/route/route.js'
import {uploadFile} from 'uni-helpers/protocol/network/upload-file.js'
import {upx2px} from 'uni-helpers/protocol/base/upx2px.js'
      export default {
        $emit,
$on,
addInterceptor,
arrayBufferToBase64,
base64ToArrayBuffer,
canIUse,
canvasToTempFilePath,
chooseFile,
chooseImage,
chooseVideo,
connectSocket,
createCanvasContext,
downloadFile,
getStorageSync,
navigateBack,
navigateTo,
reLaunch,
redirectTo,
removeStorageSync,
request,
setClipboardData,
setNavigationBarColor,
setStorageSync,
showLoading,
showModal,
showToast,
switchTab,
uploadFile,
upx2px
      }
      